/**
 * Mapping de las fases por defecto
 */
export const DEFAULT_PHASES = [
  {
    text: "Por Asignar",
    value: "unassigned",
    data: { phase: "active", tracking_phase: "unassigned", operation_phase: "" }
  },
  {
    text: "Asignado",
    value: "assigned",
    data: { phase: "active", tracking_phase: "assigned", operation_phase: "" }
  },
  {
    text: "Por Perfilar",
    value: "to-contact",
    data: { phase: "active", tracking_phase: "to-contact", operation_phase: "" }
  },
  {
    text: "Búsqueda",
    value: "searching",
    data: { phase: "active", tracking_phase: "searching", operation_phase: "" }
  },
  {
    text: "Seguimiento",
    value: "tracking",
    data: { phase: "active", tracking_phase: "tracking", operation_phase: "" }
  },
  {
    text: "Recorrido",
    value: "scheduled-tour",
    data: {
      phase: "active",
      tracking_phase: "scheduled-tour",
      operation_phase: ""
    }
  },
  {
    text: "Seguimiento post-recorrido",
    value: "finished-tour",
    data: {
      phase: "active",
      tracking_phase: "finished-tour",
      operation_phase: ""
    }
  },
  {
    text: "Ofertando",
    value: "offer",
    data: { phase: "active", tracking_phase: "offer", operation_phase: "" }
  },
  {
    text: "Apartado",
    value: "downpayment",
    data: {
      phase: "active",
      tracking_phase: "downpayment",
      operation_phase: ""
    }
  },
  {
    text: "Promesa",
    value: "contract",
    data: {
      phase: "in-operation",
      tracking_phase: "",
      operation_phase: "contract"
    }
  },
  {
    text: "Cierre",
    value: "closing-trade",
    data: {
      phase: "in-operation",
      tracking_phase: "",
      operation_phase: "closing-trade"
    }
  },
  {
    text: "Clientes - Post-Venta",
    value: "finished",
    data: { phase: "finished", tracking_phase: "", operation_phase: "" }
  },
  {
    text: "Descartados",
    value: "discarded",
    data: { phase: "discarded", tracking_phase: "", operation_phase: "" }
  }
];
